import React, { useState, useEffect } from 'react'
import BreadCrumbComp from '../../../components/breadCrumb'
import SimpleTable from '../../../components/tables/simpleTable'
import SimpleSelect from '../../../components/selects/simpleSelect'
import LaddaButton from '../../../components/buttons/laddaButton'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { months } from '../../../constants/selectData'
import { fetchTableData, fetchProviders, deleteImport } from './nationalizationTimeService'
import { nationalizationTimeColumns } from './columns'
import { icons } from '../../../constants'
import VerificationModal from '../../../components/modals/verificationModal'

const NationalizationTime = () => {
    const navigate = useNavigate()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalRecords, setTotalRecords] = useState(0)
    const [providerOptions, setProviderOptions] = useState([])
    const [selectedRow, setSelectedRow] = useState({})
    const [openDeleteModal, setOpenDeleteModal] = useState(false)

    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth() + 1

    // Generar opciones de años (últimos 5 años)
    const yearOptions = Array.from({ length: 5 }, (_, i) => ({
        name: String(currentYear - i),
        value: currentYear - i
    }))

    const [appliedFilters, setAppliedFilters] = useState({
        providerId: null,
        mes: currentMonth,
        año: currentYear
    })

    const {
        control,
        getValues,
        reset
    } = useForm({
        defaultValues: {
            proveedor: null,
            mes: currentMonth,
            año: currentYear
        }
    })

    // Función para obtener datos de la tabla (usa filtros aplicados)
    const getTableData = async (page = 1, pageSize = 10) => {
        await fetchTableData(
            appliedFilters.providerId,
            appliedFilters.mes,
            appliedFilters.año,
            page,
            pageSize,
            setTableData,
            setTotalRecords,
            setLoading
        )
    }

    const handleFilter = () => {
        const { proveedor, mes, año } = getValues()
        const newFilters = {
            providerId: proveedor ?? null,
            mes: mes ?? currentMonth,
            año: año ?? currentYear
        }
        setAppliedFilters(newFilters)
        setCurrentPage(1)
        fetchTableData(
            newFilters.providerId,
            newFilters.mes,
            newFilters.año,
            1,
            rowsPerPage,
            setTableData,
            setTotalRecords,
            setLoading
        )
    }

    const handleClearFilters = () => {
        reset({
            proveedor: null,
            mes: currentMonth,
            año: currentYear
        })
        const cleared = {
            providerId: null,
            mes: currentMonth,
            año: currentYear
        }
        setAppliedFilters(cleared)
        setCurrentPage(1)
        fetchTableData(
            cleared.providerId,
            cleared.mes,
            cleared.año,
            1,
            rowsPerPage,
            setTableData,
            setTotalRecords,
            setLoading
        )
    }

    // Manejar cambio de página
    const handlePageChange = (page, rows) => {
        const nextPageSize = rows ?? rowsPerPage
        setCurrentPage(page)
        setRowsPerPage(nextPageSize)
        fetchTableData(
            appliedFilters.providerId,
            appliedFilters.mes,
            appliedFilters.año,
            page,
            nextPageSize,
            setTableData,
            setTotalRecords,
            setLoading
        )
    }

    // Manejar acciones de la tabla
    const handleEdit = (row) => {
        navigate(`/foreign_trade_board/nationalization_Time/create_import?id=${row.id}`)
    }

    const handleDelete = (row) => {
        setSelectedRow(row)
        setOpenDeleteModal(true)
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false)
        setSelectedRow(null)
    }

    const confirmDelete = async () => {
        if (!selectedRow?.id) return

        await deleteImport(selectedRow.id, () => {
            handleCloseDeleteModal()
            getTableData(currentPage, rowsPerPage)
        })
    }

    // Botones de acción para la tabla
    const actionButtons = [
        {
            type: "icon",
            icon: icons.editBlue,
            onClick: handleEdit
        },
        {
            type: "icon",
            icon: icons.redTrash,
            onClick: handleDelete
        }
    ]

    // Cargar datos iniciales
    useEffect(() => {
        getTableData(currentPage, rowsPerPage)
        fetchProviders(setProviderOptions)
    }, [])

    const handleAddImport = () => {
        navigate('/foreign_trade_board/nationalization_Time/create_import')
    }

    return (
        <div>
            <BreadCrumbComp />
            <div className="searchTitle">
                <h1>TIEMPO DE NACIONALIZACIÓN</h1>
            </div>

            <div className="table-container">
                <div className="HContainer j-space-between a-center">
                    <h1 className="title-bio-details-chard">
                        TIEMPO DE NACIONALIZACIÓN
                    </h1>

                    <LaddaButton
                        variant="contained"
                        onClick={handleAddImport}

                        backgroundColor="#6C5CE7"
                    >
                        <div className="IHContainer align-center">
                            <img
                                className="btn-icon"
                                src={icons.plusIcon}
                                alt="icon"
                                style={{ marginRight: "10px" }}
                            />
                            <p className="button_text"> Agregar Importación</p>
                        </div>
                    </LaddaButton>
                </div>

                <div className="mb-10">
                    <form>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} md={3}>
                                <p className="info-label">Seleccionar Proveedor</p>
                                <SimpleSelect
                                    name="proveedor"
                                    control={control}
                                    options={providerOptions}
                                    margin={"0"}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <p className="info-label">Seleccionar Mes</p>
                                <SimpleSelect
                                    name="mes"
                                    control={control}
                                    options={months}
                                    margin={"0"}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <p className="info-label">Seleccionar Año</p>
                                <SimpleSelect
                                    name="año"
                                    control={control}
                                    options={yearOptions}
                                    margin={"0"}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <div className="IHContainer">
                                    <LaddaButton
                                        variant="contained"
                                        onClick={handleFilter}
                                        margin="0"
                                    >
                                        <img
                                            className="btn-icon"
                                            src={icons.filterWhite}
                                            alt="Filtrar"
                                        />
                                    </LaddaButton>
                                    <LaddaButton
                                        variant="contained"
                                        onClick={handleClearFilters}
                                        margin="0 0 0 10px"
                                    >
                                        <img
                                            className="btn-icon"
                                            src={icons.clearFilterWhite}
                                            alt="Limpiar filtros"
                                        />
                                    </LaddaButton>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </div>

                <SimpleTable
                    data={tableData}
                    columns={nationalizationTimeColumns}
                    buttons={actionButtons}
                    isPaginated={true}
                    serverPagination={true}
                    totalRecords={totalRecords}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    scrollHeight="600px"
                    emptyMessage="No se han encontrado registros"
                />
            </div>

            {/* Modal de confirmación de eliminación */}
            <VerificationModal
                open={openDeleteModal}
                handleClose={handleCloseDeleteModal}
                alertText={
                    <>
                        <b>¿Estás seguro que deseas eliminar esta importación?</b>
                        {selectedRow && (
                            <div style={{ marginTop: '10px', fontSize: '14px' }}>
                                <p>Nro. de Orden: {selectedRow.orderNumber}</p>
                                <p>Proveedor: {selectedRow.provider}</p>
                            </div>
                        )}
                    </>
                }
                onConfirm={confirmDelete}
                iconSeverity="danger"
                yesNo={true}
            />

        </div>
    )
}

export default NationalizationTime
